export enum PermissionCode {
  VIEW_DASHBOARD = 'VIEW_DASHBOARD',
  VIEW_LISTINGS = 'VIEW_LISTINGS',
  MANAGE_LISTINGS = 'MANAGE_LISTINGS',
  VIEW_ENQUIRIES = 'VIEW_ENQUIRIES',
  MANAGE_ENQUIRIES = 'MANAGE_ENQUIRIES',
  VIEW_BOOKINGS = 'VIEW_BOOKINGS',
  MANAGE_BOOKINGS = 'MANAGE_BOOKINGS',
  PAY_BOOKINGS = 'PAY_BOOKINGS',
  VIEW_USERS = 'VIEW_USERS',
  MANAGE_USERS = 'MANAGE_USERS',
  VIEW_TRANSACTIONS = 'VIEW_TRANSACTIONS',
  VIEW_SUBSCRIPTIONS = 'VIEW_SUBSCRIPTIONS',
  MANAGE_SUBSCRIPTIONS = 'MANAGE_SUBSCRIPTIONS',
  VIEW_ADMINS = 'VIEW_ADMINS',
  MANAGE_ADMINS = 'MANAGE_ADMINS',
  VIEW_OPS_CONFIG = 'VIEW_OPS_CONFIG',
  MANAGE_OPS_CONFIG = 'MANAGE_OPS_CONFIG',
  VIEW_ROLES = 'VIEW_ROLES',
  MANAGE_ROLES = 'MANAGE_ROLES',
  TOP_UP_WALLET = 'TOP_UP_WALLET'
  // Note: Additional permissions (MANAGE_PAYMENT_LINK, MANAGE_SUPPLIER, etc.) are fetched from backend API
}

export const PERMISSION_CODES = Object.values(PermissionCode);

export interface PermissionPayload {
  code: string | PermissionCode;
  name: string;
  module: string;
  description: string;
}

export interface Permission extends PermissionPayload {
  id: string;
  is_active: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MyPermissionsResponse {
  success: boolean;
  data: Permission[];
}
